import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useLocation } from "wouter";
import type { OidcRuntimeConfig } from "@/auth/config";

function isLocalhostEnvironment(): boolean {
  const { hostname } = window.location;
  return hostname === "localhost" || hostname === "127.0.0.1";
}

type DebugViewProps = {
  config: Pick<OidcRuntimeConfig, "authority" | "scope">;
};

export function DebugView({ config }: DebugViewProps) {
  const auth = useAuth();
  const [, setLocation] = useLocation();
  const isLocalhost = isLocalhostEnvironment();

  useEffect(() => {
    if (!isLocalhost || auth.isAuthenticated) {
      setLocation("/", { replace: true });
    }
  }, [isLocalhost, auth.isAuthenticated, setLocation]);

  if (!isLocalhost || auth.isAuthenticated) {
    return null;
  }

  const handleStandardSignIn = () => {
    void auth.signinRedirect();
  };

  const handleProxySignIn = () => {
    window.location.assign("/?proxy=true");
  };

  return (
    <main className="app-shell">
      <section className="panel narrow">
        <p className="eyebrow">Debug</p>
        <h1>Sign in</h1>
        <div style={{ display: "flex", gap: "1rem", marginTop: "1.5rem" }}>
          <button className="button primary" onClick={handleStandardSignIn}>
            Sign in
          </button>
          <button className="button secondary" onClick={handleProxySignIn}>
            Sign in (CORS Workaround)
          </button>
        </div>
        <dl className="details-list">
          <div>
            <dt>Authority</dt>
            <dd>{config.authority}</dd>
          </div>
          <div>
            <dt>Scope</dt>
            <dd>{config.scope}</dd>
          </div>
        </dl>
      </section>
    </main>
  );
}
